




























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { Branch, CrudDialogMode } from '../utils/types'
import { uploadImage } from '../utils/helpers'

@Component
export default class BranchCrud extends Vue {
  @Prop(String) title!: string
  @Prop(Object) branch?: Branch
  @Prop(Number) mode!: CrudDialogMode
  data: Branch = this.branchPropData
  imageForUpload: File | null = null
  selectedImageName = ''
  isLoading = false

  @Watch('branch')
  onBranchPropChange () {
    this.data = this.branchPropData
    this.imageForUpload = null
  }

  handleImageSelected (event: Event) {
    const target = event.target as HTMLInputElement
    this.imageForUpload = target.files?.item(0) || null
  }

  emitClose () {
    this.$emit('close')
  }

  async emitSubmit () {
    if (this.imageForUpload) {
      this.isLoading = true
      this.data.image = await uploadImage(this.imageForUpload)
      this.isLoading = false
    }
    this.$emit('submit', this.data)
  }

  get branchPropData () {
    return {
      id: this.branch?.id ?? '',
      name: this.branch?.name ?? '',
      jobs: this.branch?.jobs ?? [],
      isArchived: this.branch?.isArchived ?? false,
      image: this.branch?.image
    }
  }

  get isFormVisible () {
    return (
      this.mode === CrudDialogMode.CREATE || this.mode === CrudDialogMode.EDIT
    )
  }
}
